package com.yogaaicoach.pages.workout.data.models

import kotlinx.serialization.Serializable

@Serializable
data class WorkoutDataDto(
    val exercises: List<Exercise>,
    val sections: List<WorkoutProgressSectionDto>,
) {
    fun toWorkoutData(): WorkoutData? {
        if (this.exercises.isEmpty()) {
            return null
        }

        return WorkoutData(this.exercises, this.sections)
    }
}

@Serializable
data class WorkoutProgressSectionDto(
    val type: WorkoutSectionTypeDto,
    val name: String,
    val focusAreaGuid: String? = null,
)

@Serializable
enum class WorkoutSectionTypeDto {
    WARMUP,
    FOCUS_AREA,
    COOL_DOWN,
}
